// The one place the browser tab title's shape lives. Shell (BackofficeApp)
// writes the current sidebar view here, and a full-page detail (EntryDetailShell's
// page mode) overwrites it with the entry's own title while it is open — both go
// through this so the two never drift apart. The same ' — TrustFence' suffix is
// what app/layout.tsx's metadata template renders for the pre-hydration first
// paint and for the login page.
//
// Plain data module (no 'use client', no JSX), same reasoning as
// dashboardCatalog.ts: it is imported from both client components without
// dragging anything else along.

export const TITLE_SUFFIX = 'TrustFence'

export function pageTitle(part: string): string {
  return `${part} — ${TITLE_SUFFIX}`
}

// Who owns the tab title right now. Shell sets the view's part, and an open
// full-page detail pushes its own, which wins while it is open whatever order
// the two land in. Until 2026-10-16 each wrote document.title directly, so the
// view's effect -- re-run when the brand catalog arrives after a deep link --
// put "SIBS · Domain Candidates" back over a candidate that was already open.
let viewPart = ''
const detailParts: Array<{ part: string }> = []

function applyTitle() {
  if (typeof document === 'undefined') return
  const part = detailParts.length ? detailParts[detailParts.length - 1].part : viewPart
  if (part) document.title = pageTitle(part)
}

export function setViewTitle(part: string): void {
  viewPart = part
  applyTitle()
}

/** The open detail's title; call the returned function when it closes. */
export function pushDetailTitle(part: string): () => void {
  const entry = { part }
  detailParts.push(entry)
  applyTitle()
  return () => {
    const i = detailParts.indexOf(entry)
    if (i >= 0) detailParts.splice(i, 1)
    applyTitle()
  }
}
